<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="贝展标题">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.title"
        ></a-input>
      </a-form-item>
      <a-form-item label="活动Logo">
        <UploadFile v-if="show_editor" @callback="uploaded" :mult="false" folder="exhibition" />
        <img style="max-height: 100px" :src="this.API + form.logo" alt="">
      </a-form-item>
      <a-form-item label="活动海报">
        <UploadFile v-if="show_editor" @callback="uploaded2" :mult="false" folder="exhibition" />
        <img style="max-height: 200px" :src="this.API + form.thumb" alt="">
      </a-form-item>
      </a-form-item>
      <a-form-item label="贝展简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="选择位置">
        <a-button size="small" icon="compass" @click="pos_picker_show = true"></a-button>
        {{form.lat}}<span v-if="form.lng">,</span>{{form.lng}}
      </a-form-item>
      <a-form-item label="贝展场地">
        <a-input style="width: 600px" type="text" v-model="form.place"></a-input>
      </a-form-item>
      <a-form-item label="详细地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="主办方">
        <a-input style="width: 600px" type="text" v-model="form.zhuban" placeholder="多个主办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="协办方">
        <a-input style="width: 600px" type="text" v-model="form.xieban" placeholder="多个协办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="贝展时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.start_at" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.end_at" />
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          v-if="show_editor"
          @callback="updateEditor"
          :data="form.content"
          folder="exhibition"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">更新</a-button>
    </div>

    <PosPicker v-if="pos_picker_show" @callback="gotPosition" />
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec {
  margin: 15px;
}
img {
  max-width: 100%;
}
</style>

<script>
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import moment from 'moment';
import PosPicker from '../../components/posPicker';

export default {
  components: { UploadFile, Editor, PosPicker },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      form: {},
      pos_picker_show: false,
      show_editor: false
    };
  },
  async created() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/exh/getInfo?id=" + id);
    if (r.status == 1) {

      if(r.info.start_at){
        r.info.start_at = moment(r.info.start_at)
      }
      else{
        r.info.start_at = null;
      }

      if(r.info.end_at){
        r.info.end_at = moment(r.info.end_at)
      }
      else{
        r.info.end_at = null;
      }

      console.log(r.info);
      this.form = r.info;

      this.show_editor = true
    }
  },
  methods: {
    moment,
    async sub() {
      this.form.start_at = moment(this.form.start_at).valueOf()
      this.form.end_at = moment(this.form.end_at).valueOf()

      const r = await this.$axios.post('/exh/doUpdate', this.form);
      if(r.status == 1) this.$router.back()
    },
    uploaded(file) {
      this.form.logo = file.file_path;
    },

    uploaded2(file) {
      this.form.thumb = file.file_path;
    },
    
    updateEditor(data) {
      this.form.content = data;
    },

    gotPosition (pos) {
      this.pos_picker_show = false;
      this.form.place = pos.poiname;
      this.form.addr = pos.poiaddress;
      this.form.lat = pos.latlng.lat;
      this.form.lng = pos.latlng.lng;
    }
  },
};
</script>